import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

// Shared Components
import NavAero from "./Components/NavAero/NavAero";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";
import "./Styles/variables.css";

// Main Page Components
import Hero from "./Pages/MainPage/Hero";
import About from "./Pages/MainPage/About";
import Products from "./Pages/MainPage/Products";
import Team from "./Pages/MainPage/Team";
import FAQ from "./Pages/MainPage/FAQ";
import CaseStudies from "./Pages/MainPage/CaseStudies";

// Subpage Components
import App1Page from "./Pages/App1/App1Page";
// import App2Page from "./Pages/App2/App2Page";
import App4Page from "./Pages/App4/App4Page";
import App5Page from "./Pages/App5/App5Page";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import JobsPage from "./Pages/Jobs/JobsPage";

// Wrapper Component
const Wrapper = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const pathClassMap = {
      "/": "main-page",
      "/biolingo": "app1-page",
      "/happimeter": "app4-page",
      "/chatAnalyzer": "app5-page",
    };
  
    const currentPath = `/${location.pathname.split("/")[1]}`;
    const currentClass = pathClassMap[currentPath] || "main-page";
  
    // Update the body class only if it's different
    if (document.body.className !== currentClass) {
      document.body.className = currentClass;
    }
  
    return () => {
      // Clean up body class when the component unmounts
      document.body.className = "";
    };
  }, [location]);
  

  return <>{children}</>;
};

const App = () => {
  return (
    <Router>
      <Wrapper>
        <NavAero />
        <Routes>
          {/* Main Page */}
          <Route
            path="/"
            element={
              <>
                <Hero />
                <About />
                <Products />
                <CaseStudies />
                <Team />
                <FAQ />
                <Contact />
                <Footer />
              </>
            }
          />

          {/* Subpages */}
          <Route path="/biolingo" element={<App1Page />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
          <Route path="/happimeter" element={<App4Page />} />
          <Route path="/chatAnalyzer" element={<App5Page />} />
          <Route path="/jobs" element={<JobsPage />} />
          
          {/* Jobs Pages */}

          {/* Fallback Route */}
          <Route path="*" element={<div>Page Not Found</div>} />
        </Routes>
      </Wrapper>
    </Router>
  );
};

export default App;
